import { cn } from '@/shared/shadcn/lib/utils';

const buttonStyles = {
  base: 'inline-flex items-center justify-center transition-all px-3 font-pretendard cursor-pointer disabled:cursor-not-allowed',
  size: {
    large: 'py-4 text-dbase font-medium',
    medium: 'py-[0.875rem] text-dbase font-medium',
    small: 'py-2 text-dbase font-semibold',
    extraSmall: 'py-2 text-dsm font-medium',
  },
  variant: {
    primary: { default: 'bg-blue-400 text-basic-white', hover: 'hover:bg-[#1998F0]', disabled: 'bg-blue-gray-500 text-basic-white' },
    secondary: {
      default: 'bg-basic-white text-blue-700 border border-blue-700',
      hover: 'hover:bg-blue-50',
      disabled: 'border border-blue-gray-400 bg-basic-white text-blue-gray-500',
    },
    tertiary: { default: 'bg-blue-50 text-support-blue', hover: 'hover:bg-blue-100', disabled: 'bg-blue-gray-500 text-basic-white' },
    gray: {
      default: 'bg-basic-white text-gray-900 border border-table-line',
      hover: 'hover:bg-gray-100',
      disabled: 'bg-gray-300 text-gray-700 border border-table-line',
    },
    warning: {
      default: 'bg-basic-white text-state-error border border-state-error',
      hover: 'hover:bg-red-100',
      disabled: 'bg-gray-300 text-gray-700 border border-gray-300',
    },
  },
  shape: {
    round: 'rounded-[6.25rem]',
    square: 'rounded-lg',
  },
} as const;

export const getButtonClasses = (
  size: keyof typeof buttonStyles.size = 'medium',
  variant: keyof typeof buttonStyles.variant = 'primary',
  shape: keyof typeof buttonStyles.shape = 'round',
  disabled: boolean = false,
  className?: string
) => {
  return cn(
    buttonStyles.base,
    buttonStyles.size[size],
    buttonStyles.shape[shape],
    disabled
      ? buttonStyles.variant[variant].disabled // ✅ disabled 스타일
      : `${buttonStyles.variant[variant].default} ${buttonStyles.variant[variant].hover}`, // ✅ 기본 스타일
    className
  );
};
